import { render, staticRenderFns } from "./DigiBoardDetails.vue?vue&type=template&id=6c3ba37e&scoped=true"
import script from "./DigiBoardDetails.vue?vue&type=script&lang=js"
export * from "./DigiBoardDetails.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardDetails.vue?vue&type=style&index=0&id=6c3ba37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ba37e",
  null
  
)

export default component.exports